import Login from "./Login";
import Register from "./Register";
import ForgotPassword from "./ForgotPassword";
import Profile from "./Profile";


export default [
    {
        name: "app.login",
        path: "/login",
        component: Login,
        meta: { requiresAuth: false }
    },
    {
        name: "app.register",
        path: "/register",
        component: Register,
        meta: { requiresAuth: false }
    },
    {
        name: "app.password.forgot",
        path: "/forgot",
        component: ForgotPassword,
        meta: { requiresAuth: false }
    },
    {
        name: "app.user.profile",
        path: "/profile",
        component: Profile,
        meta: { requiresAuth: true }
    },
  ];